<template>
  <section class="section pt-5 container">
    <div class="title is-5">{{ $t("customer info") }}</div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("token") }}</label>
          <p class="control is-expanded has-icons-left">
            <input
              type="text"
              class="input"
              v-model="meta.token"
              :placeholder="$t('enter token')"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-font"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("get") }}</label>
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-search"></i></span>
            <span>{{ $t("search") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TokenIGSSIndex",
  components: {},
  data() {
    return {
      meta: {
        token: "",
      },
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
